import "../../styles/components/ProfileSummaryCard.css";

const ProfileSummaryCard = ({
  profile = {},
  licences = [],
  specialties = [],
}) => {
  const firstName =
    profile.first_name ||
    profile.firstName ||
    "";

  const lastName =
    profile.last_name ||
    profile.lastName ||
    "";

  const initials = `${firstName[0] || ""}${
    lastName[0] || ""
  }`.toUpperCase();

  const fullName =
    `${firstName} ${lastName}`.trim() ||
    "Professional";

  const profession =
    profile.profession_name ||
    profile.profession ||
    "Healthcare Professional";

  const province =
    profile.province ||
    profile.state ||
    "Ontario";

  const email =
    profile.email ||
    "Not provided";

  const phone =
    profile.phone ||
    profile.phone_number ||
    "Not provided";

  const primaryLicence =
    licences.find((licence) => {
      return (
        licence.is_primary === true ||
        licence.is_primary === 1 ||
        licence.is_primary === "1" ||
        licence.isPrimary === true ||
        licence.isPrimary === 1
      );
    }) ||
    licences[0] ||
    null;

  const primarySpecialty =
    specialties.find((specialty) => {
      return (
        specialty.is_primary === true ||
        specialty.is_primary === 1 ||
        specialty.is_primary === "1" ||
        specialty.isPrimary === true ||
        specialty.isPrimary === 1 ||
        specialty.primary === true ||
        specialty.primary === 1
      );
    }) ||
    specialties[0] ||
    null;

  const licenceNumber =
    primaryLicence?.licence_number ||
    primaryLicence?.license_number ||
    primaryLicence?.registration_number ||
    "Not added";

  const specialtyName =
    primarySpecialty?.specialty_name ||
    primarySpecialty?.specialty ||
    primarySpecialty?.name ||
    "Not selected";

  return (
    <section className="profile-summary-card">
      <div className="profile-summary-top">
        <div className="profile-avatar">
          {initials || "HP"}
        </div>

        <div className="profile-summary-name">
          <h2>{fullName}</h2>
        </div>

        <p className="profile-profession">
          {profession}
        </p>

        <span className="profile-location">
          📍 {province}
        </span>

        <span className="status-pill active">
          Active
        </span>
      </div>

      <div className="profile-summary-grid">
        <div className="summary-item">
          <span>Primary Licence</span>

          <strong>
            {licenceNumber}
          </strong>
        </div>

        <div className="summary-item">
          <span>Primary Specialty</span>

          <strong>
            {specialtyName}
          </strong>
        </div>

        <div className="summary-item">
          <span>Email</span>

          <strong className="profile-summary-email">
            {email}
          </strong>
        </div>

        <div className="summary-item">
          <span>Phone</span>

          <strong className="profile-summary-phone">
            {phone}
          </strong>
        </div>
      </div>
    </section>
  );
};

export default ProfileSummaryCard;